import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'
import { generateRandomString } from './common';

export const fetchDeviceReminders = async (deviceId) => {
    return apiGet({ endpoint: `${process.env.REACT_APP_REMINDER_API_URL}/get_all_reminders/${deviceId}`, error_message: "Failed to load reminders" });
};

export const createReminder = async (reminderData) => {
    return apiPost({ endpoint: `${process.env.REACT_APP_REMINDER_API_URL}`, body: reminderData, error_message: "Failed to create reminder" });
};

export const updateReminder = async (reminderData) => {
    return apiPut({ endpoint: `${process.env.REACT_APP_REMINDER_API_URL}`, body: reminderData, error_message: "Failed to update record" });
};

export const deleteReminder = async (reminderId) => {
    return apiDelete({ endpoint: `${process.env.REACT_APP_REMINDER_API_URL}/${reminderId}`, successMessage: "Reminder deleted!", error_message: "Failed to delete reminder" });
};

export const uploadReminderImage = async (reminderId, imageFile) => {
    if (!imageFile || !reminderId) {
        return { success: false, error: 'Missing required parameters' };
    }

    const formData = new FormData();
    formData.append('file', imageFile);

    try {
        const response = await fetch(
            `${process.env.REACT_APP_REMINDER_API_URL}/add_image?Id=${reminderId}`,
            {
                method: 'POST',
                headers: {
                    'portalscope': 'b3NMWOVzfdRUjrW',
                    'validatereq': generateRandomString(30)
                },
                body: formData,
                credentials: 'include',
            }
        );

        if (response.ok) {
            return { success: true, message: 'Image uploaded successfully' };
        } else {
            return { success: false, error: `Failed to upload image: ${response.status}` };
        }
    } catch (error) {
        console.error('Error uploading image:', error);
        return { success: false, error: 'Failed to upload image' };
    }
};

export const deleteReminderImage = async (reminderId, wallpaperId) => {
    if (!reminderId || !wallpaperId) {
        return { success: false, error: 'Missing required parameters for image deletion' };
    }

    try {

        const url = new URL(`${process.env.REACT_APP_REMINDER_API_URL}/delete_image`);
        url.searchParams.append('Id', reminderId);
        url.searchParams.append('wallpaper_id', wallpaperId);

        const response = await fetch(
            url.toString(),
            {
                method: 'DELETE',
                headers: {
                    'portalscope': 'b3NMWOVzfdRUjrW',
                    'validatereq': generateRandomString(30)
                },
                credentials: 'include',
            }
        );

        if (response.ok) {
            return { success: true, message: 'Image deleted successfully' };
        } else {
            const errorData = await response.json();
            return { success: false, error: errorData.title || 'Failed to delete image' };
        }
    } catch (error) {
        console.error('Error deleting image:', error);
        return { success: false, error: error.message };
    }
};